import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RULE_CATEGORY_DELETE_REQUEST = 'DELETE_RULE_CATEGORY_REQUEST';
export const RULE_CATEGORY_DELETE_FAILURE = 'DELETE_RULE_CATEGORY_FAILURE';
export const RULE_CATEGORY_DELETE_SUCCESS = 'DELETE_RULE_CATEGORY_SUCCESS';

export const deleteRuleCategory = (id, rule) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.RULE_CATEGORIES.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id, rule));
                dispatch(addSuccessMessage('Rule category successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return { type: RULE_CATEGORY_DELETE_REQUEST }
};

const deleteFailure = error => {
    return { type: RULE_CATEGORY_DELETE_FAILURE, error }
};

const deleteSuccess = (ruleCategory, rule) => {
    return { type: RULE_CATEGORY_DELETE_SUCCESS, ruleCategory, rule }
};